import { withBase } from 'ufo'
import { groupProducts, productSchema, productsSchema } from '~/utils/crystallize/product'

const ROOT_PATH = '/produktkatalog'

/**
 * Fetch a single product from the product catalogue.
 *
 * @param slug - The product's slug in Crystallize.
 */
export function useProduct(slug: MaybeRefOrGetter<string>) {
  const options = useCatalogueQueryOptions({
    path: () => withBase(toValue(slug), ROOT_PATH),
    schema: productSchema,
  })

  return useQuery(options)
}

export type CrystallizeProduct = VueQueryData<typeof useProduct>

export type CrystallizeProductVariant = CrystallizeProduct['variants'][number]

export function useProductCatalogue() {
  const options = useCatalogueQueryOptions({ path: ROOT_PATH, schema: productsSchema })

  return useQuery({
    ...options,
    select: groupProducts,
  })
}
